import { useCallback, useEffect, useState } from "react";
import { ComboBoxComponent } from "../../../../../components/comboBox/ComboBoxComponent";
import { ComboBoxIDS } from "../../../../../components/generic/ComboBoxIDS";
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer";
import { UseComboModelo } from "../../../../../hooks/auxiliar/combo/UseComboModelo";
import { UseComboGeneric } from "../../../../../hooks/hazard/combo/UseComboGeneric";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import EquipoModeloService from "../../../../../services/ListaVerificacion/EquipoModeloService";
import { UseComboOperador } from "../../../reportes/historicoEstadoEquipo/panelHistoricoEstadoFiltro/UseComboOperador";
import { UsePanelNuevoEquipoModeloOperador } from "./UsePanelNuevoEquipoModeloOperador";
import { Ifilter } from "../../../../../Interfaces/filter";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";

export const PanelNuevoEquipoModeloOperador = (props: IOpenPanel) => {
  const { dataComboOperador, setFilterOperador, filterOperador } =
    UseComboOperador(props.isOpen, true);
const [filter, setFilter] = useState<Ifilter>({
      skip: 0,
      take: 20,
      search: ""
  });
 const comboElementos = UseComboGeneric({isOpen:props.isOpen,filter:filter,
      setFilter:setFilter,fetchData:EquipoModeloService.GetEquipoModeloAuxiliar});
 
  const usePanel = UsePanelNuevoEquipoModeloOperador(props);
  const onRenderFooter = useCallback(
          () => (
            <>
              <PanelFooter
                texto="Guardar"
                texto2={"Salir"}
                disableButton={usePanel.disableForm}
                onClick={usePanel.CrearRelacion}
                onDismiss={() => {
                   usePanel.reset()
                }}
              />
            </>
          ),
          [ usePanel.disableForm, usePanel.request]
        );
    
  return (
    <PanelDrawer
      isOpen={props.isOpen}
      textHeader={"Insertar"}
      status={usePanel.status}
      mensaje={usePanel.mensaje}
      loading={usePanel.loading}
      onDismiss={usePanel.reset}
      onRenderFooter={onRenderFooter}
    >
      <ComboBoxComponent
        text="Operador:"
        placeholder="Seleccione un Operador"
        data={dataComboOperador}
        onChange={(value) => {
          setFilterOperador({
            ...filterOperador,
            search: value,
          });
        }}
        onOptionSelect={(event,option)=>{
           if(option!=undefined){
              usePanel.changeOperadoriD(option)
           }
        }}
      />
      <ComboBoxComponent
        text="Equipo Modelo:"
        placeholder="Seleccione un Equipo Modelo"
        data={comboElementos.dataCombo}
        onChange={(value) => {
            comboElementos.onChangeGeneric(value)
       }}
       onOptionSelect={(event,option)=>{
        if(option!=undefined){
           usePanel.changeModeloiD(option)
        }
     }}
      />
     
    </PanelDrawer>
  );
};
